import React, { useState, useEffect } from 'react'
import { getCookie, setCookie } from '../../utils/cookies'
import './CookieConsent.css'

const COOKIE_CONSENT_KEY = 'sarahadom_cookie_consent'

export default function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (getCookie(COOKIE_CONSENT_KEY)) return
    setVisible(true)
  }, [])

  const accept = () => {
    setCookie(COOKIE_CONSENT_KEY, 'accepted', { days: 365 })
    setVisible(false)
  }

  const decline = () => {
    setCookie(COOKIE_CONSENT_KEY, 'declined', { days: 90 })
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="cookie-consent" role="dialog" aria-label="Cookie consent">
      <div className="cookie-consent-inner">
        <p className="cookie-consent-text">
          We use cookies to improve your experience, remember your preferences, and understand how the site is used.
          By continuing, you accept our use of cookies.{' '}
          <a href="/contact" className="cookie-consent-link">Privacy & contact</a>
        </p>
        <div className="cookie-consent-actions">
          <button type="button" onClick={decline} className="cookie-consent-btn cookie-consent-btn-secondary">
            Decline
          </button>
          <button type="button" onClick={accept} className="cookie-consent-btn cookie-consent-btn-primary">
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}
